@if (product?.description) {
<section class="product-description-container">
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <h2 class="mat-headline-2" i18n="@@featureProductDetails-productDescription">Produktbeschreibung</h2>
        <planone-expandable-text
          [text]="product?.description | WYSIWYGTagFilter"
          backgroundColor="255, 255, 255"></planone-expandable-text>
      </div>
    </div>
  </div>
</section>
} @if (tags.length > 0) {
<section class="product-tags-container">
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <planone-expandable-chip-list
          [fairId]="fairId"
          [chips]="tags"
          [threshold]="8"
          [offset]="false"
          [chipsListClickable]="chipsListClickable"></planone-expandable-chip-list>
      </div>
    </div>
  </div>
</section>
}
